import { withState } from 'recompose';

export default withState('success', 'updateSuccess', null);
